import React, {Component} from "react";
import SVG from "react-inlinesvg";
import closeicon from "../../assets/close.svg";

class banner extends Component{
   constructor(props) {
      super(props);
      this.state = {

      };
   }
   render() {
      return(
          <div className="banner-container">
             <div className="closeBtn" onClick={() => this.props.toggleModal('banner',false)}>
                <SVG src={closeicon}/>
             </div>
             <p>{this.props.message}</p>
          </div>
      )
   }
}

export default banner;